import React, { useState } from 'react';
import { Menu, MenuTrigger, MenuPopover, MenuList, MenuItem } from '@fluentui/react-components';
import { ChevronDown12Regular } from '@fluentui/react-icons';
import styles from './css/index.module.css';
import { getStatusOptionsForProject } from '../../utils/taskSchedulingUtils';
import { useSelector } from 'react-redux';

const BulkStatusUpdateMenu = ({ selectedRows, onStatusSelect, children }) => {
    const { selectedProject } = useSelector(state => state.projectData);
    const statusOptions = getStatusOptionsForProject(selectedProject);
    const [open, setOpen] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);

    const handleBulkStatusChange = async status => {
        if (!selectedRows || selectedRows.length === 0 || !onStatusSelect) return;

        setIsUpdating(true);
        try {
            await onStatusSelect(status, selectedRows);
            setOpen(false);
        } catch (error) {
            console.error('Error updating bulk task status:', error);
        } finally {
            setIsUpdating(false);
        }
    };

    return (
        <Menu open={open} onOpenChange={(e, data) => setOpen(data.open)}>
            <MenuTrigger>
                {children || (
                    <div className={styles.bulkUpdateMenu} style={{ opacity: isUpdating ? 0.6 : 1 }}>
                        Status <ChevronDown12Regular className="ms-1" />
                    </div>
                )}
            </MenuTrigger>
            <MenuPopover style={{ width: '118px', minWidth: '118px' }}>
                <MenuList>
                    {statusOptions.map(opt => (
                        <MenuItem
                            key={opt.value}
                            className={styles.statusMenuItem}
                            onClick={() => handleBulkStatusChange(opt.value)}
                            style={{
                                backgroundColor: opt.bg,
                                color: opt.color,
                                border: opt.border,
                                opacity: isUpdating ? 0.6 : 1,
                                cursor: isUpdating ? 'not-allowed' : 'pointer',
                            }}>
                            {opt.label}
                        </MenuItem>
                    ))}
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};

export default BulkStatusUpdateMenu;
